/**
 * Created by Simon Zhao on 7/20/21.
 * Description:
 * The NG Module for MDL Dialog
 * ------ maintenance history ------
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WidgetsModule } from '../../widgets/widgets.module';
import { ButtonsModule, DropDownButtonModule } from '@progress/kendo-angular-buttons';
import { ChartModule } from '@progress/kendo-angular-charts';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { PopupModule } from '@progress/kendo-angular-popup';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { NoteAttachmentBufferModule } from '../note-attachment-buffer/note-attachment-buffer.module';
import { NoteAttachmentsModule } from '../note-attachments/note-attachment.module';
import { TemplateModule } from '../template/template.module';
import { TagInputModule } from 'ngx-chips';
import { MdlDialogComponent } from './mdl-dialog.component';
import { MdlDialogFieldSectionComponent } from './mdl-dialog-field-section/mdl-dialog-field-section.component';
import { MdlDialogSectionAddButtonComponent } from './mdl-dialog-section-add-button/mdl-dialog-section-add-button.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MdlDialogFieldSectionProviderItemComponent } from './mdl-dialog-field-section/mdl-dialog-field-section-provider-item/mdl-dialog-field-section-provider-item.component';

@NgModule({
    imports: [
        CommonModule,
        WidgetsModule,
        // kendo
        ButtonsModule,
        ChartModule,
        DateInputsModule,
        DropDownButtonModule,
        DropDownsModule,
        InputsModule,
        PopupModule,
        TooltipModule,
        DialogsModule,
        ReactiveFormsModule,
        TagInputModule,

        TemplateModule,
        NoteAttachmentsModule,
        NoteAttachmentBufferModule,
    ],
    declarations: [
        MdlDialogComponent,
        MdlDialogFieldSectionComponent,
        MdlDialogSectionAddButtonComponent,
        MdlDialogFieldSectionProviderItemComponent,
    ],
    exports: [
        MdlDialogComponent,
    ],
    providers: []
})
export class MdlDialogModule { }
